import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';

import withStyles from 'isomorphic-style-loader/withStyles';

// Redux
import { connect } from 'react-redux';
import { doRemoveLogo, doUploadLogo, startLogoUploaderLoader, stopLogoUploaderLoader } from '../../../../actions/siteadmin/manageHomeLogo';

// Component
import Loader from '../../../Loader/Loader';

// Translation
import { injectIntl } from 'react-intl';
import messages from '../../../../locale/jsonMessages';

import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay';
import { logouploadDir } from '../../../../config';
import { photosShow } from '../../../../helpers/photosShow';
import { withQuery } from '../../../../hoc/withGraphql';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import cp from '../../../../components/commonStyle.css';
import s from './HomeLogo.css';
class Uploader extends React.Component {

  static propTypes = {
    homeLogoUploaderLoading: PropTypes.bool,
    doRemoveLogo: PropTypes.any.isRequired,
    getHomeLogoData: PropTypes.shape({
      loading: PropTypes.bool,
      getHomeLogo: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    })
  };

  static defaultProps = {
    profilePictureData: {
      loading: true
    },
    homeLogoUploaderLoading: false
  };

  success = async (file, fromServer) => {
    const { doUploadLogo, getHomeLogoData: { getHomeLogo }, startLogoUploaderLoader, stopLogoUploaderLoader, demoRestriction } = this.props;
    let fileName = fromServer.file.filename,
      oldPicture = getHomeLogo ? getHomeLogo.value : null,
      filePath = fromServer.file.path;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await startLogoUploaderLoader();
    await doUploadLogo(fileName, filePath, oldPicture);
    await stopLogoUploaderLoader();
  }

  deleteImage = async () => {
    const { doRemoveLogo, getHomeLogoData: { getHomeLogo }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await doRemoveLogo(getHomeLogo?.value);
  }

  render() {
    const { getHomeLogoData: { loading, getHomeLogo }, doRemoveLogo, homeLogoUploaderLoading } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(logouploadDir);

    return (
      <div>
        <CommonImageDisplay
          loading={loading}
          image={getHomeLogo?.value && path + getHomeLogo?.value}
          isDefaultPic={getHomeLogo?.value ? false : true}
          loader={homeLogoUploaderLoading}
          deleteImage={this.deleteImage}
          isDelete={true}
        />
        <ImageUploadComponent
          defaultMessage={formatMessage(messages.clickHeretoUploadLogo)}
          componentConfig={{
            iconFiletypes: ['.jpg', '.png', '.jpeg'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: '/uploadHomeLogo'
          }}
          loaderName={'homeLogoUploaderLoading'}
          success={this.success}
          className={cp.spaceTop3}
        />
      </div >
    );
  }
}

const mapState = (state) => ({
  homeLogoUploaderLoading: state.loader.homeLogoUploaderLoading
});

const mapDispatch = {
  doRemoveLogo,
  doUploadLogo,
  startLogoUploaderLoader,
  stopLogoUploaderLoader,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(cp, s),
  connect(mapState, mapDispatch),
  withQuery(gql`
          query getHomeLogo{
            getHomeLogo {
            id
          title
          name
          value
          type
        }
      }
          `, {
    name: 'getHomeLogoData',
    options: {
      ssr: false
    }
  }),
)(Uploader);